import { ShowFeedbackDrawerFromTableOptions } from '@modules/quantify/components/QuantifyReportTableWidget/types';
import { useGetCompareAnalysisTableColumns } from '@modules/quantify/hooks/useGetQuantifyReportTableColumns/useGetCompareAnalysisTableColumns';
import { useGetNormalAnalysisTableColumns } from '@modules/quantify/hooks/useGetQuantifyReportTableColumns/useGetNormalAnalysisTableColumns';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { FormulaQueryProperty } from '@modules/quantify/store/types';
import { GridColDef, GridColumnGroupingModel } from '@mui/x-data-grid-pro';

interface useGetQuantifyReportTableColumnsOptions {
  onFeedbackCountClick?: (params: ShowFeedbackDrawerFromTableOptions) => void;
  shouldShowRadioColumn?: boolean;
  selectionModel?: string[];
  totalFeedbackCount?: number;
  shouldHideActions?: boolean;
  formulaID: FormulaQueryProperty['eqlFunction'];
  isCompactTableVariant?: boolean;
  shouldShowAddToFilterForBothCompareFields?: boolean;
  shouldShowCompareFieldHeaderTooltip?: boolean;
  shouldShowMergeWithSelectedReasonsAction?: boolean;
}

export const useGetQuantifyReportTableColumns = ({
  onFeedbackCountClick = () => {},
  shouldShowRadioColumn,
  selectionModel,
  shouldHideActions = false,
  formulaID,
  isCompactTableVariant = false,
  shouldShowAddToFilterForBothCompareFields = true,
  shouldShowCompareFieldHeaderTooltip = false,
  shouldShowMergeWithSelectedReasonsAction = true,
}: useGetQuantifyReportTableColumnsOptions): {
  columns: GridColDef[];
  columnGroupingModel: GridColumnGroupingModel;
} => {
  const compareTo = useQuantifyStore(({ query }) => query.compareQuery);

  const normalAnalysisTableColumns = useGetNormalAnalysisTableColumns({
    onFeedbackCountClick,
    shouldShowRadioColumn,
    selectionModel,
    shouldHideActions,
    formulaID,
    isCompactTableVariant,
    shouldShowMergeWithSelectedReasonsAction,
  });

  const compareAnalysisTableColumns = useGetCompareAnalysisTableColumns({
    onFeedbackCountClick,
    shouldHideActions,
    formulaID,
    isCompactTableVariant,
    shouldShowAddToFilterForBothCompareFields,
    shouldShowCompareFieldHeaderTooltip,
    shouldShowMergeWithSelectedReasonsAction,
  });

  return compareTo ? compareAnalysisTableColumns : normalAnalysisTableColumns;
};
